export default __webpack_public_path__ + "static/media/slide-3-mobile.b580a2ec.png";